import type { ReactElement } from 'react';

export function MaintenancePage(): ReactElement {
  return (
    <main>
      <h1>Oasis est en maintenance</h1>
      <p>Une mise à jour est en cours. Le service revient dans quelques minutes.</p>
    </main>
  );
}
